import React from 'react'
import i18next from 'i18next'
import { CourseSearchState } from './courseSearchState'
import { CourseSearchBlock } from './courseSearchBlock'
import { ComponentPageheader } from '../../../Styleguide/structure/custom/components/pageheaders'
import { PaginationLayout } from '../../pagination/paginationLayout'
import { datalayerHandler } from '../../utils/datalayer'
import { maybeToMailPlusLink } from '../../utils/mailplus'
import { Link } from 'widgets-for-react'

export const CourseSearchLayout = (props: CourseSearchState) => {
  const location = window.location
  // @todo: get rid of useeffect
  React.useEffect(() => {
    document.title = i18next.t('search:searchInCourses');
  }, []);

  React.useEffect(() => {
    if (props.result.kind === 'loaded') {
      datalayerHandler(
        'search_opleidingen',
        props.result.value.Resources.length > 0 ? 'result' : 'no_result',
        'search_opleidingen',
        { label: props.query })
    }

  }, [props.result.kind]);
  return (
    <>
      {ComponentPageheader(false, false, {
        title:
        "Zoeken"
      }).run(() => {})}

      <CourseSearchBlock
        query={props.query || ""}
        page={props.page || 1}
        disabled={props.result.kind === 'loading'} />

      <div className="block block--listing">
        <div className="block__inner container--s spacing--mx gutter--m">
          <h2 className="sr-text">{i18next.t("search:searchInCourses")}</h2>

          {props.query && props.result.kind === 'loaded' ?
            <div className="block__content">
              <section className="listing">
                <div className="listing__inner">
                  <header className="listing__header">
                    <h3 className="listing__title title--s">
                      {props.result.kind === 'loaded'
                        ? props.result.value.Total
                        : 0} {i18next.t("search:resultsFound")}
                    </h3>
                  </header>

                  <div className="listing__content">
                    <ul className="listing__list">
                      {(props.result.kind === 'loaded'
                        ? props.result.value.Resources
                        : []).map(r => (
                          <li className="listing__item" key={r.Resource.AbsolutePath}>
                            <Link
                              className="listing__link"
                              to={r.Resource.AbsolutePath}
                              onClick={() =>
                                datalayerHandler('search_opleidingen_ctr', 'yes', 'search_opleidingen_ctr', {
                                  kind: 'link',
                                  label: r.Resource.HeaderTitle,
                                  link: maybeToMailPlusLink(r.Resource.AbsolutePath)
                                })}>
                              <article className="listingitem">
                                <header className="listingitem__header">
                                  <p className="listingitem__label label--m">{i18next.t(`contentType:${r.Resource.ContentType.replace(/\s+/g, '')}`)}</p>
                                  <h4 className="listingitem__title title--m">{r.Resource.HeaderTitle}</h4>
                                </header>

                                <div className="listingitem__content">
                                  <div className="listingitem__intro text--l">{r.Resource.HeaderDescription}</div>
                                  {/* <p className="listingitem__meta text--xs">{fakeButtonLabel}</p> */}
                                </div>
                              </article>
                            </Link>
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
              </section>
            </div> : null
          }
        </div>
      </div>
      {props.result.kind === 'loaded' && <PaginationLayout
        currentPage={props.page || 1}
        totalPages={Math.ceil(props.result.value.Total / props.result.value.PerPage)}
        toPage={page => `${location.pathname}?${new URLSearchParams({page: page.toString(), search: props.query || '' }).toString()}`}
      />}

    </>
  )
}
